export function useObserver(callback, options = {}, root = document.body) {
    if (typeof callback !== 'function') {
        throw new Error('useObserver: callback must be a function');
    }

    const defaultOptions = {
        childList: true,
        subtree: true,
    };

    const observer = new MutationObserver(callback);
    observer.observe(root, { ...defaultOptions, ...options });

    callback();

    function cleanup() {
        observer.disconnect();
    }

    return { cleanup, observer };
}
